import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.y{align-items:center;}.ssr-plugin'
import '.ax{gap:2rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.d6{text-align:center;}.ssr-plugin'
import '.bj{background-color:var(--brand-accent);}.ssr-plugin'
import '.ha{padding:0.25rem 1rem;}.ssr-plugin'
import '.hb{border-radius:1.75rem;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Button } from '@app/components/core/button/Button'
import { pages } from '@app/util/links'

export type LandingHeroProps = {
  badge: string
  title: string
  description: string
  ctaLabel?: string
  ctaTo?: string
  style?: Style
}

const LandingHero = ({
  badge,
  title,
  description,
  ctaLabel = 'Plan een demo',
  ctaTo = pages.contactUs,
  style,
}: LandingHeroProps) => {
  return (
    <styled.div className="d e y ax l d6"
      style={{
        ...style,
      }}
    >
      <span className="bj ha hb"
      >
        <Text.Small isBold>{badge}</Text.Small>
      </span>
      <Title.H1
        style={{
          marginBottom: 0,
          maxWidth: '57rem',
        }}
      >
        {title}
      </Title.H1>
      <Text.Medium
        style={{
          marginBottom: 0,
          maxWidth: '45rem',
        }}
      >
        {description}
      </Text.Medium>
      <Button label={ctaLabel} to={ctaTo} />
    </styled.div>
  )
}

export default LandingHero
